module.exports = __webpack_public_path__ + "static/the-quest-e41bc85725a42ba91639434eeca9ddc6.jpg";